import type { FC } from "react";
import { useCurrentUser } from "../../../../hooks/use-current-user";
import { usePostReactions } from "../../../../hooks/use-post-reactions";
import type { PostType } from "../../../../types/post.types";
import EmojiButton from "../../../emoji-button/emoji-button";
import { usePostBroadcastContext } from "../../post-broadcast.context";
import PostActions from "../post-actions/post-actions";

type PostFooterProps = {
	postId: string;
	postType: PostType;
	hideReactions?: boolean;
};

const PostFooter: FC<PostFooterProps> = ({
	postId,
	postType,
	hideReactions,
}) => {
	const { broadcastId, broadcastUserId } = usePostBroadcastContext();
	const currentUser = useCurrentUser();

	const uid = currentUser?.uid ?? null;
	const isAuthor = !!uid && uid === broadcastUserId;
	const { counts, react } = usePostReactions(broadcastId, postId, uid);

	const disabled = isAuthor || !uid;

	return (
		<div
			style={{
				width: "100%",
				display: "flex",
				justifyContent: hideReactions ? "flex-end" : "space-between",
				marginTop: "0.8rem",
			}}
		>
			{!hideReactions && (
				<div style={{ display: "flex", gap: "0.5rem" }}>
					<EmojiButton
						disabled={disabled}
						onClick={() => react("thumbs_up")}
						reactionType="thumbs_up"
						value={counts.thumbs_up}
					/>
					<EmojiButton
						disabled={disabled}
						onClick={() => react("thumbs_down")}
						reactionType="thumbs_down"
						value={counts.thumbs_down}
					/>
				</div>
			)}
			{isAuthor && <PostActions postId={postId} postType={postType} />}
		</div>
	);
};

export default PostFooter;
